module.exports = "../../app/cells/pages/landing_xray/index/details_cell.rb";